import { GraphMutationBuilderPayload, createMutation } from '@camelot/server';

import { QuotationCreationPayloadInput } from './dto/quotation-creation-payload-input';
import { QuotationModifierPayloadInput } from './dto/quotation-modifier-payload-input';
import { QuotationVersionCreationPayloadInput } from './dto/quotation-version-creation-payload-input';
import { QuotationVersionModifierPayloadInput } from './dto/quotation-version-modifier-payload-input';
import { RefusalInfos } from './dto/refusal-infos';
import { quotationVersionProps } from './dto/version';

export function READ_QUOTATION_VERSION(id: string): GraphMutationBuilderPayload {
  return createMutation('quotationVersionRead', {
    argument: 'quotationVersionId',
    props: `
      ${quotationVersionProps.get('id')}
      ${quotationVersionProps.get('isNew')}
    `,
    type: 'UUID!',
    value: id,
  });
}

export function QUOTATION_VERSION_REFUSED(
  quotationVersionId: string,
  refusalInfos: RefusalInfos
): GraphMutationBuilderPayload {
  return createMutation('quotationVersionRefused', {
    args: {
      quotationVersionId: { type: 'UUID!', value: quotationVersionId },
      refusalInfos: {
        type: 'QuotationVersionRefusalInfoPayloadInput!',
        value: { comment: refusalInfos.content, reason: refusalInfos.reason },
      },
    },
    props: `
      ${quotationVersionProps.get('id')}
      ${quotationVersionProps.get('status')}
    `,
  });
}

export function CREATE_QUOTATION(payload: QuotationCreationPayloadInput): GraphMutationBuilderPayload {
  return createMutation('createQuotation', {
    props: '',
    type: 'QuotationCreationPayloadInput!',
    value: payload,
  });
}

export function CREATE_QUOTATION_VERSION(payload: QuotationVersionCreationPayloadInput): GraphMutationBuilderPayload {
  return createMutation('createQuotationVersion', {
    props: '',
    type: 'QuotationVersionCreationPayloadInput!',
    value: payload,
  });
}

export function UPDATE_QUOTATION(payload: QuotationModifierPayloadInput): GraphMutationBuilderPayload {
  return createMutation('updateQuotation', {
    props: '',
    type: 'QuotationModifierPayloadInput!',
    value: payload,
  });
}

export function UPDATE_QUOTATION_VERSION(payload: QuotationVersionModifierPayloadInput): GraphMutationBuilderPayload {
  return createMutation('updateQuotationVersion', {
    props: '',
    type: 'QuotationVersionModifierPayloadInput!',
    value: payload,
  });
}

export function QUOTATION_VERSION_SIGNED(quotationVersionId: string): GraphMutationBuilderPayload {
  return createMutation('quotationVersionSigned', {
    argument: 'quotationVersionId',
    props: `
      ${quotationVersionProps.get('id')}
      ${quotationVersionProps.get('status')}
    `,
    type: 'UUID!',
    value: quotationVersionId,
  });
}
